import { combineReducers } from 'redux';

import addPageContentError from './addPageContentError';
import addPageError from './addPageError';
import deletePageError from './deletePageError';
import deletePageContentError from './deletePageContentError';
import editPageContentError from './editPageContentError';
import editPageNameError from './editPageNameError';
import loadSiteStaticPagesError from './loadSiteStaticPagesError';
import setPageContentAvailabilityError from './setPageContentAvailabilityError';


export default combineReducers({
  addPageContentError,
  addPageError,
  deletePageError,
  deletePageContentError,
  editPageContentError,
  editPageNameError,
  loadSiteStaticPagesError,
  setPageContentAvailabilityError,
});
